module.exports = __webpack_public_path__ + "static/media/royal_gaming.c74d670d.svg";